import { provideHttpClient, withFetch } from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  provideRouter,
  withInMemoryScrolling,
  withViewTransitions,
} from '@angular/router';
import { ApiModule } from '@millionshow/api-client';
import { provideToastr } from 'ngx-toastr';
import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';
import { KioskConfigStore } from './stores/kiosk-config.store';

export const appConfig: ApplicationConfig = {
  providers: [
    provideClientHydration(withEventReplay()),
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      appRoutes,
      withViewTransitions(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      })
    ),
    provideAnimations(),
    provideToastr(),
    provideHttpClient(withFetch()),
    provideAppInitializer(() => inject(KioskConfigStore).initialize()),
    importProvidersFrom(
      ApiModule.forRoot({
        rootUrl: environment.baseUrl,
      })
    ),
  ],
};
